import { useTranslation } from "react-i18next";

import StaticLevelPreview from "@/components/Elements/FieldPreview/StaticLevelPreview";

/**
 * @param {"severity"|"consequence"|"probability"|"risk"} field
 */
export default function (field) {
  const { t } = useTranslation("severity");

  const values = Array.from({ length: 5 }, (_, i) => i + 1);
  values.push("null");

  return {
    filterMode: "tree",
    filters: values.map((value) => ({
      text:
        value === "null" ? (
          t(value)
        ) : (
          <StaticLevelPreview field={field} level={value} />
        ),
      value: value,
    })),
  };
}
